import { useMemo, useState } from 'react';
import Fuse from 'fuse.js';

interface UseAftermarketProductsSearchParams<T> {
  products: T[];
}

export const useAftermarketProductsSearch = <T extends Record<string, unknown>>({
  products,
}: UseAftermarketProductsSearchParams<T>) => {
  const [searchText, setSearchText] = useState('');

  const filteredProducts = useMemo(() => {
    if (!searchText) {
      return products;
    }

    const fuse = new Fuse(products, {
      keys: ['vendorName', 'productName'],
      threshold: 0.1,
      isCaseSensitive: false,
    });

    return fuse.search(searchText).map(result => result.item);
  }, [searchText, products]);

  return {
    searchText,
    setSearchText,
    filteredProducts,
  };
};
